// extracted by mini-css-extract-plugin
module.exports = {"name":"Item_name__6WgVm","image":"Item_image__1Zh5P"};